import axios from 'axios';


export const updateBanner = async (id,status) => {
  try {
    const res = await axios.post('/bannerUpdateStatus',{bannerId: id,status:status});
    return res.data;
  } catch (e) {
    console.error(e);
    return e.response.data;
  }
};
export const deleteBanner = async (deleteid) => {
      try {
        const res = await axios.post('/delete-banner',{id: deleteid});
        return res.data;
      } catch (e) {
        console.error(e);
        return e.response.data;
      }
};
export const addBanner = async (type, formData) => {
      const url = type === "EDIT" ? "/edit-banner" : "/addToBanner"
      try {
          const res = await axios.post(url,formData);
          return res.data;
      } catch (e) {
        console.error(e);
        return e.response.data;
      }
};
export const addProduct = async (type, formData) => {
  console.log('addProduct');
  console.log(...formData);
  const url = type === "EDIT" ? "/editProductApi" : "/addProductApi"
  try {
      const res = await axios.post(url,formData);
      return res.data;
  } catch (e) {
    console.error(e);
    return e.response.data;
  }
};
export const addCategory = async (type, formData) => {
  console.log('addCategory');
  console.log(...formData);
  const url = type === "EDIT" ? "/editCategory" : "/addcategory";
  try {
      const res = await axios.post(url,formData);
      return res.data;
  } catch (e) {
    console.error(e);
    return e.response.data;
  }
};
export const getBanner = async () => {
      try {
          const res = await axios.get('/getAllBanner');
          return res.data;
      } catch (e) {
        return e.response.data;
      }
};
